/* Aloha3D UI v03 — theme behaviour. Native Shopify forms stay the source of truth; JS only enhances. */
(function () {
  'use strict';
  var I18N = (window.A3V3 && window.A3V3.t) || {};
  var T = function (k, d) { return I18N[k] || d; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var R = (window.A3V3 && window.A3V3.routes) || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var f = (window.A3V3 && window.A3V3.money) || '${{amount}}';
    var n = (cents / 100);
    var whole = Math.round(n) === n;
    var amount = whole ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = n.toLocaleString('de-DE', { maximumFractionDigits: 0 });
    return f.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toLocaleString('en-US'))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toLocaleString('de-DE', { minimumFractionDigits: whole ? 0 : 2 }))
            .replace(/\{\{\s*amount\s*\}\}/, amount)
            .replace(/<[^>]*>/g, '');
  }
  function parseDate(s) { if (!s) return null; var d = new Date(s); return isNaN(d) ? null : d; }
  function daysLeft(s) { var d = parseDate(s); if (!d) return null; return Math.max(0, Math.ceil((d - new Date()) / 864e5)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* announcement */
  var ann = $$('[data-ann] > div');
  if (ann.length > 1 && !reduce) {
    var ai = 0;
    setInterval(function () {
      var p = ann[ai]; p.classList.remove('on'); p.classList.add('out');
      setTimeout(function () { p.classList.remove('out'); }, 340);
      ai = (ai + 1) % ann.length; ann[ai].classList.add('on');
    }, 4200);
  }

  /* header scroll + mobile bar */
  var hdr = $('[data-hdr]'), mbar = $('[data-mbar]');
  function onScroll() {
    var y = window.scrollY;
    if (hdr) hdr.classList.toggle('is-scrolled', y > 420);
    if (mbar) { var on = y > 560; mbar.classList.toggle('on', on); document.body.classList.toggle('mbar-on', on); }
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* mega menu */
  var mega = $('#mega'), shopBtn = $('#shopBtn'), megaT;
  function toggleMega(on) { if (!mega) return; mega.classList.toggle('open', on); shopBtn && shopBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
  if (mega && shopBtn) {
    [shopBtn, mega].forEach(function (el) {
      el.addEventListener('mouseenter', function () { clearTimeout(megaT); if (window.matchMedia('(hover:hover)').matches) toggleMega(true); });
      el.addEventListener('mouseleave', function () { megaT = setTimeout(function () { toggleMega(false); }, 140); });
    });
    shopBtn.addEventListener('focus', function () { toggleMega(true); });
    shopBtn.addEventListener('click', function (e) {
      if (window.matchMedia('(hover:none)').matches && !mega.classList.contains('open')) { e.preventDefault(); toggleMega(true); }
    });
    mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget) && e.relatedTarget !== shopBtn) toggleMega(false); });
  }

  /* overlays: drawer, search, filters */
  var lastFocus = null;
  function openO(id, from) {
    closeAll(true);
    var o = document.getElementById(id); if (!o) return;
    lastFocus = from || document.activeElement;
    o.classList.add('open'); o.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $$('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var f = id === 'srch' ? $('[data-sin]', o) : $('.ovl__panel button, .ovl__panel a, .ovl__panel input', o);
      f && f.focus({ preventScroll: true });
    }, 60);
  }
  function closeAll(keep) {
    $$('.ovl.open').forEach(function (o) { o.classList.remove('open'); o.setAttribute('aria-hidden', 'true'); });
    $$('[data-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    toggleMega(false);
    if (!keep && lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} lastFocus = null; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open],[data-close],[data-copy]');
    if (!t) return;
    if (t.hasAttribute('data-open')) { e.preventDefault(); openO(t.getAttribute('data-open'), t); return; }
    if (t.hasAttribute('data-close')) { e.preventDefault(); closeAll(); return; }
    if (t.hasAttribute('data-copy')) {
      var txt = t.getAttribute('data-copy'), old = t.innerHTML;
      var done = function () { t.textContent = T('copied', 'Copied'); setTimeout(function () { t.innerHTML = old; }, 1400); };
      try { navigator.clipboard.writeText(txt).then(done, done); } catch (er) { done(); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  /* close drawer when a same-page anchor is followed */
  $$('.drawer a[href*="#"]').forEach(function (a) { a.addEventListener('click', function () { closeAll(true); }); });

  /* predictive search (Shopify /search/suggest.json) */
  var sin = $('[data-sin]'), sdef = $('[data-sdefault]'), sres = $('[data-sres]'), sT, sCtl;
  function renderRes(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var rows = [];
    (r.products || []).forEach(function (p) {
      rows.push('<a href="' + p.url + '" class="srow">' + (p.image ? '<div class="ph has-img" style="--ar:1/1"><img src="' + p.image + '&width=120" alt="" loading="lazy"></div>' : '<div class="ph" style="--ar:1/1"><span>A</span></div>') +
        '<span><b>' + esc(p.title) + '</b><small>' + (p.price ? T('from', 'from') + ' ' + money(Math.round(parseFloat(p.price) * 100)) : '') + '</small></span><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>');
    });
    (r.collections || []).concat(r.pages || [], r.articles || []).forEach(function (x) {
      rows.push('<a href="' + x.url + '" class="srow"><div class="ph" style="--ar:1/1"><span>A</span></div><span><b>' + esc(x.title) + '</b><small>' + (x.handle && r.collections && r.collections.indexOf(x) > -1 ? T('collection', 'Collection') : T('page', 'Page')) + '</small></span><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>');
    });
    var all = (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    sres.innerHTML = rows.length
      ? '<div><h4>' + rows.length + ' ' + (rows.length === 1 ? T('result', 'result') : T('results', 'results')) + '</h4>' + rows.slice(0, 8).join('') + '</div><a class="btn btn--p btn--block" href="' + all + '">' + T('see_all', 'See all results for') + ' “' + esc(q) + '”</a>'
      : '<p class="sempty">' + T('no_results', 'No results for') + ' “' + esc(q) + '”. ' + T('try', 'Try “ChibiMe”, “couple” or “pet”.') + '</p>';
  }
  function doSearch(q) {
    q = q.trim();
    if (!q) { sres.hidden = true; sdef.hidden = false; return; }
    if (sCtl) sCtl.abort();
    sCtl = window.AbortController ? new AbortController() : null;
    var url = (R.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, sCtl ? { signal: sCtl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      sdef.hidden = true; sres.hidden = false; renderRes(q, d);
    }).catch(function () {});
  }
  if (sin && sres && sdef) {
    sin.addEventListener('input', function () { clearTimeout(sT); var v = sin.value; sT = setTimeout(function () { doSearch(v); }, 180); });
    $$('[data-sq]').forEach(function (b) { b.addEventListener('click', function () { sin.value = b.getAttribute('data-sq'); doSearch(sin.value); sin.focus(); }); });
  }

  /* rails: thin progress bar + arrows + dots */
  function initRails(root) {
    $$('[data-rail]', root).forEach(function (r) {
      var t = $('.rail__t', r), bar = $('.rail__bar i', r), nav = $$('.rail__nav button', r), dots = $$('.dots i', r);
      if (!t) return;
      var up = function () {
        var max = t.scrollWidth - t.clientWidth, ratio = t.scrollWidth ? t.clientWidth / t.scrollWidth : 1;
        if (bar) { bar.style.width = (ratio * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * ((1 - ratio) / ratio) * 100 : 0) + '%)'; }
        if (nav.length) { nav[0].disabled = t.scrollLeft < 4; nav[1].disabled = t.scrollLeft > max - 4; }
        if (dots.length) { var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth)); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }
      };
      t.addEventListener('scroll', up, { passive: true });
      nav.forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: (+b.getAttribute('data-dir')) * t.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }); });
      window.addEventListener('resize', up); up();
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { r.classList.toggle('near', en.isIntersecting); }); }, { threshold: 0.35 }).observe(r);
      else r.classList.add('near');
    });
  }
  initRails(document);

  /* before / after */
  $$('[data-ba]').forEach(function (b) {
    var c = $('.cmp', b), i = $('input', c);
    i.addEventListener('input', function () { c.style.setProperty('--x', i.value + '%'); });
    var thumbs = $$('.thumbs button', b);
    function setPh(el, src, label) {
      if (!el) return;
      if (src) { el.classList.add('has-img'); el.innerHTML = '<img src="' + src + '" alt="' + esc(label) + '">'; }
      else { el.classList.remove('has-img'); el.innerHTML = '<span>' + esc(label) + '</span>'; }
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        setPh($('.ph.a', c), t.getAttribute('data-before'), 'A02 · ' + T('their_photo', 'Their photo') + ' ' + (k + 1));
        setPh($('.ph.b', c), t.getAttribute('data-after'), 'A02 · ' + T('finished', 'Finished figurine') + ' ' + (k + 1));
      });
    });
    var chips = $$('.fchips button', b);
    chips.forEach(function (ch, k) {
      ch.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === ch ? 'true' : 'false'); });
        var f = ch.getAttribute('data-ft');
        thumbs.forEach(function (t) { var l = t.getAttribute('data-line'); t.hidden = !(k === 0 || !l || l === f); });
      });
    });
  });

  /* countdowns, days-left, calendars */
  $$('[data-cd]').forEach(function (cd) {
    var d = parseDate(cd.getAttribute('data-cd')); if (!d) return;
    var tick = function () {
      var ms = Math.max(0, d - new Date()), v = [Math.floor(ms / 864e5), Math.floor(ms / 36e5) % 24, Math.floor(ms / 6e4) % 60];
      $$('b', cd).forEach(function (b, i) { b.textContent = String(v[i]).padStart(2, '0'); });
    };
    tick(); setInterval(tick, 30000);
  });
  $$('[data-days]').forEach(function (el) { var n = daysLeft(el.getAttribute('data-days')); if (n !== null) el.textContent = el.textContent.replace('[days]', n); });
  $$('[data-days-n]').forEach(function (el) { var n = daysLeft(el.getAttribute('data-days-n')); if (n !== null) el.textContent = n; });
  $$('[data-until]').forEach(function (tr) { var d = parseDate(tr.getAttribute('data-until')); if (d && d < new Date()) tr.classList.add('past'); });


  /* holiday snow: light canvas, pauses off-screen, off for reduced motion */
  $$('[data-snow]').forEach(function (cv) {
    if (reduce || !cv.getContext) { cv.remove(); return; }
    var ctx = cv.getContext('2d'), flakes = [], run = false, raf, W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1);
    function size() { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, W * H / 9000)); flakes = [];
      for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: 0.8 + Math.random() * 1.8, s: 0.25 + Math.random() * 0.6, d: Math.random() * Math.PI * 2, o: 0.25 + Math.random() * 0.45 }); }
    function step() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) { var f = flakes[i]; f.y += f.s; f.d += 0.01; f.x += Math.sin(f.d) * 0.3;
        if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255,255,255,' + f.o + ')'; ctx.fill(); }
      if (run) raf = requestAnimationFrame(step);
    }
    size(); window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting && !run) { run = true; step(); } else if (!en.isIntersecting) { run = false; cancelAnimationFrame(raf); } }); }).observe(cv);
    else { run = true; step(); }
  });

  /* landing jump strip: highlight follows the section in view (as v02) */
  $$('.strip').forEach(function (strip) {
    var links = $$('a[href^="#"]', strip).filter(function (a) { return a.getAttribute('href').length > 1 && document.getElementById(a.getAttribute('href').slice(1)); });
    if (!links.length) return;
    var ticking = false;
    function spy() {
      ticking = false;
      var off = (hdr ? hdr.getBoundingClientRect().height : 0) + strip.getBoundingClientRect().height + 24, cur = links[0];
      links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t.getBoundingClientRect().top - off <= 0) cur = a; });
      $$('a', strip).forEach(function (a) { a.classList.toggle('on', a === cur); });
      var l = cur.offsetLeft - strip.scrollLeft;
      if (l < 0 || l + cur.offsetWidth > strip.clientWidth) strip.scrollTo({ left: cur.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  });

  /* newsletter: client-side check before native submit */
  $$('form[data-nl], #a3v3-nl').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var i = $('input[type=email]', f), m = $('.msg', f);
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value);
      i.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) { e.preventDefault(); m.textContent = T('email_err', 'Enter an email like you@example.com.'); i.focus(); }
    });
  });

  /* contact form validation (native submit) */
  var cf = $('#cForm');
  if (cf) cf.addEventListener('submit', function (e) {
    var ok = true;
    [['cN', function (v) { return v.trim().length > 1; }, T('name_err', 'Enter your name.')],
     ['cE', function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }, T('email_err', 'Enter an email like you@example.com.')],
     ['cM', function (v) { return v.trim().length > 4; }, T('msg_err', 'Tell us a little more so we can help.')]].forEach(function (x) {
      var i = document.getElementById(x[0]); if (!i) return;
      var bad = !x[1](i.value); i.setAttribute('aria-invalid', bad ? 'true' : 'false');
      var et = $('.err-t', i.parentElement); if (et) et.textContent = bad ? x[2] : '';
      if (bad && ok) { ok = false; i.focus(); }
    });
    if (!ok) e.preventDefault();
  });

  /* wishlist hearts: remembered in this browser */
  var W = []; try { W = JSON.parse(localStorage.getItem('a3v3-wish') || '[]'); } catch (e) {}
  $$('[data-wish]').forEach(function (b) {
    var id = b.getAttribute('data-wish');
    b.setAttribute('aria-pressed', W.indexOf(id) > -1 ? 'true' : 'false');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      W = W.filter(function (x) { return x !== id; }); if (on) W.push(id);
      try { localStorage.setItem('a3v3-wish', JSON.stringify(W)); } catch (er) {}
    });
  });

  /* collection sort (desktop select) */
  var sortS = $('[data-sort]');
  if (sortS) sortS.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sortS.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* delivery timeline */
  $$('[data-tl]').forEach(function (tl) {
    var add = function (x, n, biz) { x = new Date(x); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (!biz || (x.getDay() % 6)) k++; } return x; };
    var f = function (x) { return x.toLocaleDateString(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' }); };
    var now = new Date(), pv = add(now, +tl.getAttribute('data-pv') || 3, true), sh = add(pv, +tl.getAttribute('data-mk') || 10, true), ar = add(sh, +tl.getAttribute('data-sh') || 8, false);
    var set = function (k, v) { var el = $('[data-d="' + k + '"]', tl); if (el) el.textContent = v; };
    set('t', f(now)); set('pv', f(pv)); set('sh', f(sh)); set('ar', f(ar));
    var dl = daysLeft(tl.getAttribute('data-dl')); set('left', dl === null ? '–' : dl);
  });

  /* size guide / photo tips dialogs */
  function dlg(btnSel, dSel) {
    var b = $(btnSel), d = $(dSel); if (!b || !d || !d.showModal) return;
    b.addEventListener('click', function () { d.showModal(); });
    $$('[data-sgclose]', d).forEach(function (x) { x.addEventListener('click', function () { d.close(); }); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  }
  dlg('[data-sg]', '[data-sgd]'); dlg('[data-tips]', '[data-tipsd]');

  /* product form: options -> variant, add-ons, uploads, add to cart */
  var pf = $('#pf-main');
  if (pf) {
    var pj = {}; try { pj = JSON.parse($('[data-pjson]').textContent); } catch (e) {}
    var vid = $('[data-vid]', pf), pEls = $$('[data-price],[data-price2]'), atc = $('[data-atc]', pf), atcL = $('[data-atc-l]', pf), err = $('[data-atcerr]', pf);
    var current = null;
    function selOpts() { var o = []; $$('input[data-oi]:checked', pf).forEach(function (i) { o[+i.getAttribute('data-oi')] = i.value; }); return o; }
    function addonSum() { return $$('[data-addon]:checked', pf).reduce(function (s, x) { return s + (+x.getAttribute('data-price') || 0); }, 0); }
    function update() {
      var o = selOpts();
      if (pj.variants && o.length) {
        current = pj.variants.find(function (v) { return v.options.every(function (x, i) { return o[i] === undefined || x === o[i]; }); }) || null;
      } else if (pj.variants) current = pj.variants[0];
      $$('[data-ol]').forEach(function (l) { var k = +l.getAttribute('data-ol'); if (o[k] !== undefined) l.textContent = o[k]; });
      if (!current) { atc.disabled = true; atcL.textContent = T('unavailable', 'Unavailable'); return; }
      vid.value = current.id;
      var total = current.price + addonSum();
      pEls.forEach(function (el) { el.textContent = money(el.hasAttribute('data-price') ? current.price : total); });
      $$('[data-vnd]').forEach(function (el) { var rate = +el.getAttribute('data-vnd') || 0; if (!rate) return; var v = Math.ceil(current.price / 100 * rate / 1000) * 1000; el.textContent = '\u2248 ' + v.toLocaleString('vi-VN') + ' \u0111'; });
      atc.disabled = !current.available; atcL.textContent = current.available ? T('add_to_cart', 'Add to cart') : T('sold_out', 'Sold out');
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u.toString()); }
    }
    pf.addEventListener('change', function (e) { if (e.target.matches('[data-oi],[data-addon]')) update(); });
    /* landing builder hand-off: ?people=N&note=... */
    var qs = new URLSearchParams(location.search);
    if (qs.get('people')) {
      $$('input[data-oi]', pf).forEach(function (i) { if (i.value.replace('+', '') === qs.get('people').replace('+', '')) i.checked = true; });
    }
    if (qs.get('note')) { var gn = $('[data-giftnote]', pf); gn.value = qs.get('note').slice(0, 140); gn.disabled = false; }
    update();

    $$('[data-up]', pf).forEach(function (u) {
      var inp = $('input', u);
      inp.addEventListener('change', function () {
        var f = inp.files && inp.files[0], e2 = $('[data-uperr]', pf);
        if (!f) return;
        if (f.size > 20 * 1024 * 1024) { u.classList.add('err'); e2.textContent = T('file_big', 'That file is over 20 MB. Try a smaller photo.'); inp.value = ''; return; }
        u.classList.remove('err'); e2.textContent = '';
        var rd = new FileReader();
        rd.onload = function () { $('.ico', u).innerHTML = /^image\/(jpe?g|png|webp|gif)$/.test(f.type) ? '<img alt="" src="' + rd.result + '">' : ''; };
        rd.readAsDataURL(f);
        u.classList.add('has');
        $('b', u).textContent = f.name.length > 28 ? f.name.slice(0, 26) + '…' : f.name;
        $('small', u).textContent = T('ready', 'Ready to upload ✓ · tap to change');
      });
    });

    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      err.textContent = '';
      var req = $('[data-up][data-req]', pf), ri = req && $('input', req);
      if (ri && !ri.files.length) {
        req.classList.add('err'); $('[data-uperr]', pf).textContent = T('need_photo', 'Add a photo of each person first. We need it to sculpt the 3D preview.');
        req.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return;
      }
      atc.disabled = true; atcL.textContent = T('adding', 'Adding…');
      var fd = new FormData(pf);
      $$('input[data-oi]', pf).forEach(function (i) { fd.delete(i.name); });
      $$('[data-addon]', pf).forEach(function (i) { fd.delete(i.name); });
      $$('input[type=file]', pf).forEach(function (i) { if (!i.files.length) fd.delete(i.name); });
      var addons = $$('[data-addon]:checked', pf).map(function (i) { return { id: +i.value }; });
      fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (!addons.length) return null;
          return fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: addons.map(function (a) { return { id: a.id, quantity: 1 }; }) }) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
        })
        .then(function () { atcL.textContent = T('added', 'Added to cart ✓'); location.href = R.cart || '/cart'; })
        .catch(function (j) { atc.disabled = false; atcL.textContent = T('add_to_cart', 'Add to cart'); err.textContent = (j && (j.description || j.message)) || T('error', 'Something went wrong. Please try again.'); });
    });
  }

  /* landing gift builder */
  $$('[data-builder]').forEach(function (b) {
    var extra = (+b.getAttribute('data-extra') || 0) * 100;
    var note = $('[data-bnote]', b), cnt = $('[data-bcnt]', b), go = $('[data-bgo]', b);
    function upd() {
      var st = $('input[name^="bs-"]:checked', b), pp = $('input[name^="bp-"]:checked', b);
      if (!st || !pp) return;
      var p = +pp.value, n = note.value.trim();
      $('[data-bname]', b).textContent = st.getAttribute('data-name');
      $('[data-bmeta]', b).textContent = (p === 4 ? '4+' : p) + ' ' + (p > 1 ? T('people', 'people') : T('person', 'person')) + ' · ' + (n ? T('note_added', 'gift note added') : T('note_none', 'gift note not added'));
      $('[data-btot]', b).textContent = money((+st.getAttribute('data-from')) + (p - 1) * extra);
      cnt.textContent = note.value.length + ' / 140';
      var img = st.getAttribute('data-img'), box = $('[data-bimg]', b);
      if (img) { box.classList.add('has-img'); box.innerHTML = '<img src="' + img + '" alt="">'; } else { box.classList.remove('has-img'); box.innerHTML = '<span>A03</span>'; }
      var url = st.value || st.getAttribute('data-url') || (R.root || '/') + 'collections/all';
      var q = new URLSearchParams(); q.set('people', p === 4 ? '4+' : String(p)); if (n) q.set('note', n);
      go.href = url + (url.indexOf('?') > -1 ? '&' : '?') + q.toString();
    }
    b.addEventListener('input', upd); b.addEventListener('change', upd); upd();
  });

  /* cart quantity +/- (native cart update) */
  var cform = $('[data-cartform]');
  if (cform) {
    $$('.citem', cform).forEach(function (row) {
      var line = +row.getAttribute('data-line'), span = $('.qty span', row);
      $$('[data-q]', row).forEach(function (b) {
        b.addEventListener('click', function () {
          var q = Math.max(0, (+span.textContent) + (+b.getAttribute('data-q')));
          span.textContent = q; row.style.opacity = '.55';
          fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
            .then(function () { location.reload(); }).catch(function () { location.reload(); });
        });
      });
    });
  }
})();
